module.exports = __webpack_public_path__ + "static/img/solution_img_5.303cc5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/nav/img/nav-solution/solution-n/solution_img_5.png
// module id = WDuC
// module chunks = 22